import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MotionConfig } from "framer-motion";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { createBrowserRouter, RouterProvider } from "react-router";
import { routes } from "./config/router";
import { ErrorFallback } from "./general/errors/ErrorFallback";
import { subscribeToUIStateStorage } from "./uiState/uiState";

const reactQueryClient = new QueryClient();

const router = createBrowserRouter(routes);

const Provider = () => {
  useEffect(subscribeToUIStateStorage, []);

  return (
    <MotionConfig reducedMotion="user">
      <QueryClientProvider client={reactQueryClient}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </QueryClientProvider>
    </MotionConfig>
  );
};

export default Provider;
